import axios from "axios";

export default {
  namespaced: true,
  state: {
    districts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    districtsMessage: ''
  },
  mutations: {
    CLEAR_DISTRICTS(state) {
      state.districts = [];
    },
    RECEIVED_DISTRICTS(state, payload) {
      state.districts = payload;
      state.isReceiving = false;
    },
    RECEIVING_DISTRICTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_DISTRICT(state, payload) {
      state = Object.assign(state, {
        districts: [...state.districts, payload],
        isReceiving: false,
      })
    },
    RECEIVING_DISTRICT(state) {
      state.isReceiving = true;
    },
    UPDATED_DISTRICT(state, payload) {
      let index = state.districts.findIndex(district => district._id === payload._id);
      state = Object.assign(state, {
        districts: state.districts.map((district, i) => {
          if (i === index) {
            return Object.assign({}, district, payload);
          }
          return district;
        }),
        isUpdating: false,
        districtsMessage: 'Districts has been updating!',
      })
    },
    UPDATING_DISTRICT(state) {
      state.isUpdating = true;
    },
    DELETED_DISTRICT(state, payload) {
      let indexToDelete = state.districts.findIndex(district => district._id === payload._id);
      let districts = [...state.districts];
      districts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        districts: [...districts],
        isDeleting: false,
        idToDelete: null,
        districtsMessage: 'District has been Deleted!',
      });
    },
    DELETING_DISTRICT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteDistrictRequest({dispatch}, payload) {
      dispatch("deletingDistrict", payload);
      axios.delete('https://api.tradexc.com:3000/delete/district/' + payload._id)
      .then((response) => {
        dispatch("deleteDistrict", response.data);
      })
    },
    async getDistrictsRequest({dispatch}) {
      dispatch("receivingDistricts");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/districts';
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: header})
      .then(response => {
        dispatch("receiveDistricts", response.data);
      })
    },
    async insertDistrictRequest({dispatch}, payload) {
      dispatch("receivingDistricts");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/district';
      let data = payload;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: header, data: data})
      .then(function (response) {
        dispatch("receiveDistrict", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async updateDistrictRequest({dispatch}, payload) {
      dispatch("updatingDistrict");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/district/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "POST", url: url, headers: header, data: payload})
      .then(function (response) {
        dispatch("updateDistrict", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    updateDistrictImageRequest({dispatch}, payload) {
      dispatch("updatingDistrict");
      var data;
      var header;
      var token = localStorage.getItem('token');
      var id = payload._id;
      delete payload['_id'];

      var url = 'https://api.tradexc.com:3000/update/district/image/' + id;
      data = new FormData();
      data.append('image', payload.districtimage, payload.imagename); 
      delete payload['districtimage'];
      for (let x in payload) {
        data.append(x, payload[x]);
      }
      header = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token
      };

      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };

      axios(post)
      .then(function (res) {
        dispatch("updateDistrict", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    
    clearDistricts({commit}) {
      commit("CLEAR_DISTRICTS")
    },
    receiveDistricts({commit}, payload) {
      commit("RECEIVED_DISTRICTS", payload)
    },
    receivingDistricts({commit}) {
      commit("RECEIVING_DISTRICTS")
    },
    receiveDistrict({commit}, payload) {
      commit("RECEIVED_DISTRICT", payload)
    },
    receivingDistrict({commit}) {
      commit("RECEIVING_DISTRICT")
    },
    updateDistrict({commit}, payload) {
      commit("UPDATED_DISTRICT", payload)
    },
    updatingDistrict({commit}) {
      commit("UPDATING_DISTRICT")
    },
    deleteDistrict({commit}, payload) {
      commit("DELETED_DISTRICT", payload)
    },
    deletingDistrict({commit}, payload) {
      commit("DELETING_DISTRICT", payload)
    }
  },
};
